// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2VxSQ","header":"ClearentDisclaimer_header__3mVqI","inner":"ClearentDisclaimer_inner__RqvCS"};